// extracted by mini-css-extract-plugin
export default {"ActionWelcome":"ActionWelcome_ActionWelcome__kQuir"};